function setEqualHeight(selector) {
    let elements = document.querySelectorAll(selector);
    let maxHeight = 0;

    // Find the maximum height
    elements.forEach(el => {
        el.style.height = 'auto'; // Reset height to get natural height
        maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    // Apply the maximum height to all elements
    elements.forEach(el => {
        el.style.height = maxHeight + 'px';
    });
}

// Run on page load
window.addEventListener('load', () => setEqualHeight('.product-card-wrapper .price'));

// Run on window resize (to adjust dynamically)
window.addEventListener('resize', () => setEqualHeight('.product-card-wrapper .price'));



// 

  document.addEventListener("shopify:section:load", function () {
    if (window.judgeme && judgeme.renderBadges) {
      judgeme.renderBadges();
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (window.judgeme && judgeme.renderBadges) {
      judgeme.renderBadges();
    }
  });
